import { styled } from '@clickcease/cc-client-components-lib'

export const UserManagementTableStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
})

export const UserManagementTableHeader = styled('div', {
  display: 'flex',
  width: '100%',
  height: '48px',
  justifyContent: 'space-around',
  ['div:first-of-type']: {
    paddingLeft: '13px',
  },
})

export const HeaderPart = styled('div', {
  display: 'flex',
  width: '100%',
  color: '$mainTextColor',
  justifyContent: 'start',
  fontWeight: '$rb',
  fontSize: '$md',
  lineHeight: '63px',
  borderBottom: 'solid 1px #CACACA',
})

export const UserManagementTableContent = styled('div', {
  height: '100%',
  paddingBottom: '20px',
})
